module.exports = __webpack_public_path__ + "static/media/cammino_2.fe67be8f.jpg";